import Vue from 'vue';

export const componentMode = Vue.observable({ isEditMode: false });
